import { Trans } from '@lingui/macro';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import NgpTwoButtonDialog from '../../dialog-two-button/NgpTwoButtonDialog';

/**
 * Confirmation dialog used when deleting a Test Type. Mirrors the portal/ui
 * action-dialog look & feel: a red ("md-warn") title bar with white text,
 * a bold black body line and a destructive "Delete" action button.
 *
 * Built on top of NgpTwoButtonDialog so we reuse the shared two-button /
 * isActioning / cancel logic. The red title bar is achieved by passing a
 * styled title node that uses negative margins to extend over DialogTitle's
 * default padding (16px 24px).
 */
const useStyles = makeStyles((theme) => ({
    titleBar: {
        margin: theme.spacing(-2, -3),
        padding: theme.spacing(0, 2, 0, 3),
        backgroundColor: theme.palette.error.main,
        color: theme.palette.error.contrastText,
        display: 'flex',
        alignItems: 'center',
        fontSize: '1.25rem',
        fontWeight: 500,
        height: 64,
    },
    body: {
        fontWeight: 'bold',
        color: theme.palette.text.primary,
        margin: theme.spacing(3, 0),
    },
}));

function TestTypeDeleteDialog({ open, setOpen, onConfirm }) {
    const classes = useStyles();

    const titleNode = <div className={classes.titleBar}>{<Trans>Delete Test Type?</Trans>}</div>;

    return (
        <NgpTwoButtonDialog
            title={titleNode}
            open={open}
            setOpen={setOpen}
            onConfirm={onConfirm}
            isWarning
            confirmButtonText={<Trans>Confirm</Trans>}
            cancelButtonText={<Trans>Cancel</Trans>}
            closeInTitleBar={false}
        >
            <Box width={650}>
                <h2 className={classes.body}>
                    <Trans>This action CANNOT be undone. Any Tests configured to run it will also be deleted.</Trans>
                </h2>
            </Box>
        </NgpTwoButtonDialog>
    );
}

TestTypeDeleteDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
};

export default TestTypeDeleteDialog;
